// ===== Method theme — global JS (null-safe on every page) =====
document.addEventListener('DOMContentLoaded', function () {

  // Mobile burger menu
  var burger = document.querySelector('.burger');
  if (burger) {
    burger.addEventListener('click', function () {
      var l = document.querySelector('.nav-links');
      if (!l) return;
      var open = l.style.display === 'flex';
      l.style.display = open ? 'none' : 'flex';
      if (!open) {
        l.style.position = 'absolute'; l.style.top = '70px'; l.style.left = '0'; l.style.right = '0';
        l.style.flexDirection = 'column'; l.style.background = '#06342c'; l.style.padding = '18px 24px';
        l.style.gap = '16px'; l.style.borderBottom = '1px solid rgba(8,80,65,.08)';
        l.classList.add('nav-links--open');
      }
    });
  }

  // Scroll reveal
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: .15 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  // Results 30/60-day toggle
  var rtabs = document.querySelectorAll('.res-tab'), rpanels = document.querySelectorAll('.res-panel');
  rtabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      rtabs.forEach(function (t) { t.classList.remove('active'); });
      rpanels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      if (rpanels[i]) rpanels[i].classList.add('active');
    });
  });

  // Policy tabs (on policies page)
  var ptabs = document.querySelectorAll('.policy-tab'), ppanels = document.querySelectorAll('.policy-panel');
  ptabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () {
      ptabs.forEach(function (t) { t.classList.remove('active'); });
      ppanels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      if (ppanels[i]) ppanels[i].classList.add('active');
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (it) {
        it.classList.remove('open');
        var aa = it.querySelector('.faq-a'); if (aa) aa.style.maxHeight = null;
      });
      if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  // ---- Interactive tropical hero background (only if canvas exists) ----
  var canvas = document.getElementById('tropicalCanvas');
  if (canvas && canvas.getContext) {
    var ctx = canvas.getContext('2d');
    var W, H, dpr;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mouse = { x: -999, y: -999 };
    function resize() { dpr = Math.min(window.devicePixelRatio || 1, 2); W = canvas.clientWidth; H = canvas.clientHeight; canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    var COLORS = ['#c0285a', '#d4537e', '#1d9e75', '#9fe1cb'];
    var gummies = [];
    function makeGummies() { gummies = []; var n = W < 700 ? Math.max(5, Math.round(W / 130)) : Math.max(9, Math.round(W / 85)); for (var i = 0; i < n; i++) { gummies.push({ x: Math.random() * W, y: Math.random() * H, r: 14 + Math.random() * 22, vx: (Math.random() - .5) * .25, vy: (Math.random() - .5) * .25, rot: Math.random() * Math.PI, vr: (Math.random() - .5) * .01, c: COLORS[Math.floor(Math.random() * COLORS.length)], a: .32 + Math.random() * .4 }); } }
    function drawSun() { var g = ctx.createRadialGradient(W * 0.82, H * 0.18, 10, W * 0.82, H * 0.18, W * 0.5); g.addColorStop(0, 'rgba(255,255,255,.5)'); g.addColorStop(1, 'rgba(255,255,255,0)'); ctx.fillStyle = g; ctx.fillRect(0, 0, W, H); }
    var t = 0;
    function drawPalm(x, baseY, scale, dir, sway) { ctx.save(); ctx.translate(x, baseY); ctx.scale(dir * scale, scale); ctx.rotate(Math.sin(t * 0.4 + sway) * 0.04); ctx.fillStyle = 'rgba(8,80,65,0.09)'; for (var k = 0; k < 6; k++) { ctx.save(); ctx.rotate((-0.6 + k * 0.24) + Math.sin(t * 0.5 + sway + k) * 0.03); ctx.beginPath(); ctx.moveTo(0, 0); ctx.quadraticCurveTo(70, -12, 150, -4); ctx.quadraticCurveTo(70, 8, 0, 0); ctx.fill(); ctx.restore(); } ctx.restore(); }
    function drawGummy(g) { ctx.save(); ctx.translate(g.x, g.y); ctx.rotate(g.rot); ctx.globalAlpha = g.a; ctx.fillStyle = g.c; ctx.beginPath(); ctx.ellipse(0, 0, g.r, g.r * 0.86, 0, 0, Math.PI * 2); ctx.fill(); ctx.globalAlpha = g.a * 0.5; ctx.fillStyle = 'rgba(255,255,255,0.6)'; ctx.beginPath(); ctx.ellipse(-g.r * 0.3, -g.r * 0.32, g.r * 0.22, g.r * 0.16, 0, 0, Math.PI * 2); ctx.fill(); ctx.restore(); }
    function frame() { ctx.clearRect(0, 0, W, H); drawSun(); drawPalm(-10, H, 1.1, 1, 0); drawPalm(W + 10, H * 0.96, 1.25, -1, 2); gummies.forEach(function (g) { var dx = g.x - mouse.x, dy = g.y - mouse.y, d = Math.hypot(dx, dy); if (d < 120) { var f = (120 - d) / 120 * 1.6; g.vx += dx / d * f * 0.12; g.vy += dy / d * f * 0.12; } g.x += g.vx; g.y += g.vy; g.rot += g.vr; g.vx *= 0.985; g.vy *= 0.985; g.vy += Math.sin(t + g.x * 0.01) * 0.0015; if (g.x < -40) g.x = W + 40; if (g.x > W + 40) g.x = -40; if (g.y < -40) g.y = H + 40; if (g.y > H + 40) g.y = -40; drawGummy(g); }); t += 0.016; if (!reduce) requestAnimationFrame(frame); }
    function init() { resize(); makeGummies(); if (reduce) { frame(); } else { requestAnimationFrame(frame); } }
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      // On mobile, scrolling toggles the address bar which fires resize with a changed HEIGHT only.
      // Ignore those — only rebuild when the WIDTH actually changes (real resize / rotation).
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      resize();
      makeGummies();
    });
    var heroEl = document.querySelector('.hero');
    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    if (heroEl && !isTouch) {
      heroEl.addEventListener('mousemove', function (e) { var r = canvas.getBoundingClientRect(); mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top; });
      heroEl.addEventListener('mouseleave', function () { mouse.x = -999; mouse.y = -999; });
    }
    init();
  }

});
var heroStage = document.getElementById('heroBottleStage');
if (heroStage && 'IntersectionObserver' in window) {
  var bottleObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { setTimeout(function(){ heroStage.classList.add('slid-out'); }, 400); }
    });
  }, { threshold: 0.35 });
  bottleObs.observe(heroStage);
} else if (heroStage) {
  heroStage.classList.add('slid-out');
}
